import * as Common from "../../commons/common"

export class Sheet {
  id: number
  exec_date: string
  name: string
  curriculum_id: number
  subject_name: string
  subject_code: string
  sheet_type: number
  digital_sheet_published: boolean
  result_published: boolean
  result_image_published: boolean
  is_uploaded: boolean
  student_no: number
  url: string
  answer_limit: string = "-"

  constructor(sheet: any){
    this.id = sheet.id;
    this.exec_date = Common.formatDate(sheet.exec_date, "Y年M月D日");
    this.name = sheet.name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.subject_code = sheet.subject_code;
    this.sheet_type = sheet.sheet_type;
    this.digital_sheet_published = sheet.digital_sheet_published;
    this.result_published = sheet.result_published;
    this.result_image_published = sheet.result_image_published;
    this.is_uploaded = sheet.is_uploaded;
    this.student_no = sheet.student_no;
    this.url = sheet.url;
    if(sheet.test_start_datetime_at && sheet.test_end_datetime_at){
      this.answer_limit = `${Common.formatDate(sheet.test_start_datetime_at, "M月D日 HH:mm")} 〜 ${Common.formatDate(sheet.test_end_datetime_at, "M月D日 HH:mm")}`;
    }
  }
}